module.exports = __webpack_public_path__ + "static/media/default-image.bef4333a.png";